module.exports = __webpack_public_path__ + "static/img/rrrr_29.b955b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_29.png
// module id = mPGB
// module chunks = 1